import "../css/CigarIndiv.css";
import {useState} from "react";
import CigarDialog from "./CigarDialog";

const CigarIndiv = (props) => {
    const [showPop, setPop] = useState(false);

    const showPopDetails = () => {
        setPop(true);
    }
    const hidePopDetails = () => {
        setPop(false);
    }

    return (
        <>
            {showPop?(
                <CigarDialog closePopDialog={hidePopDetails}
                    id={props._id}
                    name={props.name}
                    image={props.image}
                    type={props.type}
                    location={props.location}
                    price={props.price} />
            ):("")}
            <section className="cigar-indiv" onClick={showPopDetails}>
                <img src={"https://server-gourmet.onrender.com/images/" + props.image} alt={props.name} />
                <h1>{props.name}</h1>
            </section>
        </>
    );
};

export default CigarIndiv;
